<template>
  <div>
    <v-btn
      v-if="filtroAVigilar.length !== 0"
      @click="verEnVivo"
      color="red"
      :class="botonEnVivoClass"
      rounded
      elevation="8"
    >
      <v-icon left>mdi-record-circle</v-icon>
      En vivo
    </v-btn>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    input: Object,
  },
  data() {
    return {
      dataList: [],
    };
  },
  computed: {
    ...mapState(["selectedItem", "pages", "selectedPage"]),
    filtroAVigilar: {
      get() {
        try {
          // console.log("LOS ITEMS", this.pages[this.selectedPage].item_list, this.input.filtroAsociado);
          const a = this.pages[this.selectedPage].item_list.find((item) => {
            return item.name === this.input.customized.filtroAsociado.name;
          });

          console.log("El elegido es", a);
          return a.customized.data;
        } catch (error) {
          return [];
        }
      },
      set(nuevosDatos) {
        try {
          const a = this.pages[this.selectedPage].item_list.find((item) => {
            return item.name === this.input.customized.filtroAsociado.name;
          });

          if (a) {
            a.customized.data = nuevosDatos;
          }
        } catch (error) {
          console.error(error);
        }
      },
    },
  },
  watch: {},
  mounted() {},
  methods: {
    verEnVivo() {
      this.filtroAVigilar = [];
    },
  },
};
</script>
<style scoped>
.en-vivo {
  background-color: green; /* Color verde indica que ya está en vivo */
  color: white;
}

.ver-en-vivo {
  background-color: red; /* Color rojo indica que puede ver en vivo */
  color: white;
}

.en-vivo:hover,
.ver-en-vivo:hover {
  opacity: 0.8;
}
</style>
